import { render, staticRenderFns } from "./BasePreloader.vue?vue&type=template&id=cb539ed6&scoped=true&"
import script from "./BasePreloader.vue?vue&type=script&lang=js&"
export * from "./BasePreloader.vue?vue&type=script&lang=js&"
import style0 from "./BasePreloader.vue?vue&type=style&index=0&id=cb539ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb539ed6",
  null
  
)

export default component.exports